import { ApiGenericResponse } from "../ApiGenericResponse";
import { ModelInfo } from "../supportObjects/ModelInfo";
import { AxiosResponse } from "axios";

export class GetSupportedModelsResponse extends ApiGenericResponse {
    models: ModelInfo[];

    constructor(response: AxiosResponse) {
        super(response);
        if (response.data && response.data.Payload) {
            this.parse(response.data.Payload);
        }
    }

    public parse(obj: any) {
        this.models = [];
        if (obj.ModelsInfos) {
            obj.ModelsInfos.forEach((e) => {
                let m = new ModelInfo();
                m.parse(e);
                this.models.push(m);
            });
        }
    }
}
